import { z } from "zod";

import { ConfigEventDso } from "../../../schemas/metas";
import { castToNumber } from "../../../utils";

export const GetConfigEventsRequestQueryParamSchema = z.object({
  startTs: castToNumber.optional(),
  endTs: castToNumber.optional(),
});
export type GetConfigEventsRequestQueryParamType = z.infer<
  typeof GetConfigEventsRequestQueryParamSchema
>;

export const GetConfigEventsResponseBodySchema = z.object({
  events: ConfigEventDso.array(),
});
export type GetConfigEventsResponseBodyType = z.infer<
  typeof GetConfigEventsResponseBodySchema
>;
